import styled from 'styled-components';

export const TestimonialContainer = styled.div(
	({ theme: { down, breakpoints } }) => `
		${down(breakpoints.tb)} {
			padding: 60px 0 30px 16px ;
			overflow: hidden;
		}

		${down(breakpoints.md)} {
			padding: 60px 0 30px 16px ;
			overflow: hidden;
		}
		padding: 100px 0 170px 0 ;
		max-width: 1200px;
		width: 100%;
		margin: 0 auto;
	`
);

export const ImageWrapper = styled.div`
	width: 143px;
	height: 52px;
	background: #eeeeee;
	border-radius: 5px;
	color: #c9c9c9;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const TestimonialTextWrap = styled.p(
	({ theme: { down, breakpoints } }) => `
		${down(breakpoints.md)} {
			flex-direction: column-reverse;
		}
		font-size: 16px;
`
);

export const TestimonialSubText = styled.p(
	({ theme: { down, breakpoints } }) => `
		margin-bottom: 40px;
		font-size: 16px;
		color: #000000;
		width: 35%;
		${down(breakpoints.md)} {
			width: 100%;
		}
	`
);

export const SliderOuterWrap = styled.div`
	>div > div > div >div {
		&.slick-slide{
			padding-right: 50px;
		}
	}

`;
